import { createFileRoute } from "@tanstack/react-router"
import { UserPage } from "~/features/user/components/user-page"

export const Route = createFileRoute("/user/$id")({
  component: UserPage,
})
